import { render, staticRenderFns } from "./SecondSponsorsByAdFrequency.vue?vue&type=template&id=1af30312&"
import script from "./SecondSponsorsByAdFrequency.vue?vue&type=script&lang=js&"
export * from "./SecondSponsorsByAdFrequency.vue?vue&type=script&lang=js&"
import style0 from "./SecondSponsorsByAdFrequency.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports